<div class="detailcontainer">
<mat-toolbar color="secondary">
  <ldw-document-title [document]="document"></ldw-document-title>
  <span class="spacer"></span>
  <div class="buttons">
    <button mat-icon-button (click)="close()" matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>
<div class="detailcontent" >
<table mat-table [dataSource]="changes" class="mat-elevation-z8">
  <ng-container matColumnDef="dateTime">
    <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.DATE'|translate}}</th>
    <td mat-cell *matCellDef="let element"> {{element.dateTime}} </td>
  </ng-container>

  <ng-container matColumnDef="user">
    <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.NAME'|translate}}</th>
    <td mat-cell *matCellDef="let element"> {{element.user}} </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.ACTION'|translate}}</th>
    <td mat-cell *matCellDef="let element"> {{element.action}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>
</div>
